import React, { useState } from 'react';
import { ThumbsUp, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { reviewsAPI } from '../services/api';

const ReviewHelpfulButton = ({ review, onChange }) => {
  const [busy, setBusy] = useState(false);
  const count = review.helpful_count || 0;

  const toggle = async () => {
    setBusy(true);
    try {
      const res = await reviewsAPI.toggleHelpful(review.id);
      onChange && onChange(res);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Vote impossible pour le moment');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2 mt-2 text-xs text-gray-500">
      <span>Cet avis vous a été utile ?</span>
      <button
        type="button"
        onClick={toggle}
        disabled={busy}
        data-testid={`review-helpful-${review.id}`}
        aria-pressed={review.voted}
        className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-medium transition-colors ${review.voted ? 'bg-orange-500 text-white border-orange-500' : 'bg-white text-gray-700 border-gray-300 hover:border-orange-400 hover:text-orange-600'}`}
      >
        {busy ? <Loader2 size={12} className="animate-spin" /> : <ThumbsUp size={12} className={review.voted ? 'fill-white' : ''} />}
        Utile{count > 0 && <span data-testid={`review-helpful-count-${review.id}`}>({count})</span>}
      </button>
    </div>
  );
};

export default ReviewHelpfulButton;
